import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Profile() {
  const [company, setCompany] = useState({
    name: '', inn: '', ogrn: '', kpp: '', address: '',
    bank_name: '', bank_account: '', director: '', phone: '',
    email: '', industry: '', tax_regime: 'УСН',
  });
  const [progress, setProgress] = useState({ progress: 0, filled: [], empty: [] });
  const [saved, setSaved] = useState(false);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetchCompany();
    fetchProgress();
  }, []);

  const fetchCompany = async () => {
    try {
      const res = await fetch(API + '/company', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const d = await res.json();
        setCompany(prev => ({ ...prev, ...d.company }));
      }
    } catch (err) { console.error(err); }
  };

  const fetchProgress = async () => {
    try {
      const res = await fetch(API + '/profile/progress', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setProgress(await res.json());
    } catch (err) { console.error(err); }
  };

  const handleChange = (key, value) => {
    setCompany(prev => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const save = async () => {
    try {
      const res = await fetch(API + '/company', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(company),
      });
      if (res.ok) {
        const d = await res.json();
        localStorage.setItem('khepri_company', JSON.stringify(d.company));
        setSaved(true);
        fetchProgress();
        setTimeout(() => setSaved(false), 3000);
      }
    } catch (err) { console.error(err); }
  };

  const getProgressColor = () => {
    if (progress.progress >= 80) return '#10B981';
    if (progress.progress >= 50) return '#F59E0B';
    return '#EF4444';
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🏢 Профиль компании</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Заполните данные — они автоматически подставятся в договоры и документы.
      </p>

      {/* Прогресс */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ color: '#F7DE8A', fontWeight: 600 }}>Заполнено</span>
          <span style={{ color: getProgressColor(), fontWeight: 700, fontSize: 20 }}>{progress.progress}%</span>
        </div>
        <div style={{ height: 12, background: '#0F172A', borderRadius: 6, overflow: 'hidden' }}>
          <div style={{ width: `${progress.progress}%`, height: '100%', background: getProgressColor(), borderRadius: 6, transition: 'width 0.3s' }} />
        </div>
        {progress.empty.length > 0 && (
          <div style={{ marginTop: 10, fontSize: 12, color: '#94A3B8' }}>
            Не заполнено: <strong style={{ color: '#F59E0B' }}>{progress.empty.join(', ')}</strong>
          </div>
        )}
      </div>

      {/* Форма */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10, maxWidth: 700 }}>
        <div>
          <label style={labelStyle}>Название компании *</label>
          <input value={company.name} onChange={e => handleChange('name', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Директор</label>
          <input value={company.director} onChange={e => handleChange('director', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>ИНН</label>
          <input value={company.inn} onChange={e => handleChange('inn', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>ОГРН</label>
          <input value={company.ogrn} onChange={e => handleChange('ogrn', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>КПП</label>
          <input value={company.kpp} onChange={e => handleChange('kpp', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Отрасль</label>
          <input value={company.industry} onChange={e => handleChange('industry', e.target.value)} placeholder="Например: мебель" style={inputStyle} />
        </div>
        <div style={{ gridColumn: 'span 2' }}>
          <label style={labelStyle}>Адрес</label>
          <input value={company.address} onChange={e => handleChange('address', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Банк</label>
          <input value={company.bank_name} onChange={e => handleChange('bank_name', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Расчётный счёт</label>
          <input value={company.bank_account} onChange={e => handleChange('bank_account', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Телефон</label>
          <input value={company.phone} onChange={e => handleChange('phone', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Email</label>
          <input value={company.email} onChange={e => handleChange('email', e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Налоговый режим</label>
          <select value={company.tax_regime} onChange={e => handleChange('tax_regime', e.target.value)} style={inputStyle}>
            <option>УСН</option>
            <option>ОСНО</option>
            <option>ПСН</option>
          </select>
        </div>
      </div>

      <button onClick={save} style={{ marginTop: 20, padding: '14px 32px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 16 }}>
        💾 Сохранить
      </button>
      {saved && <span style={{ marginLeft: 16, color: '#10B981', fontWeight: 600 }}>✅ Сохранено</span>}
    </div>
  );
}

const inputStyle = { width: '100%', padding: 10, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 13, marginTop: 4 };
const labelStyle = { color: '#94A3B8', fontSize: 12 };

export default Profile;